import * as React from "react";
import { locKeys } from "components/flexComponents/WizardFlightPWA/components/l10n";
import { PreferredClassProps } from "components/shared/PreferredClass/typings";
import { observer } from "mobx-react";
import { UitkMenu, UitkMenuTrigger, UitkMenuContainer, PositionType, UitkMenuList } from "uitk-react-menu";
import { UitkLink, UitkLinkAlign } from "uitk-react-link";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
import { UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { useLocalization } from "@shared-ui/localization-context";

export const PreferredClass = observer((props: PreferredClassProps) => {
  const { formatText } = useLocalization();

  const setFlightClassLabel = () => {
    const flightClassCode = props.wizardState.flightClassCode;

    switch (flightClassCode) {
      case "p":
        return formatText(locKeys.flightPreferredClassPremiumEconomy);
      case "b":
        return formatText(locKeys.flightPreferredClassBusiness);
      case "f":
        return formatText(locKeys.flightPreferredClassFirstClass);
      case "e":
        return formatText(locKeys.flightPreferredClassEconomy);
    }

    return locKeys.flightPreferredClassEconomy;
  };

  return (
    <UitkLayoutFlexItem>
      <UitkMenu isOpen={props.isPreferredClassMenuOpen} onTriggerClick={props.onPreferredClassMenuTriggerClick}>
        <UitkMenuTrigger>
          <UitkLink iconPos={UitkLinkAlign.RIGHT}>
            <button type="button">
              {setFlightClassLabel()}
              <UitkIcon name="expand_more" size={UitkIconSize.SMALL} />
            </button>
          </UitkLink>
        </UitkMenuTrigger>
        <UitkMenuContainer position={PositionType.LEFT}>
          <UitkMenuList
            items={[
              {
                attributes: {
                  role: "menuItem",
                  tabindex: 0
                },
                className: "uitk-list-item",
                label: formatText(locKeys.flightPreferredClassEconomy),
                typeAnchor: true,
                onClick: props.onSelectPreferredClassCode("e")
              },
              {
                attributes: {
                  role: "menuItem",
                  tabindex: 0
                },
                className: "uitk-list-item",
                label: formatText(locKeys.flightPreferredClassPremiumEconomy),
                typeAnchor: true,
                onClick: props.onSelectPreferredClassCode("p")
              },
              {
                attributes: {
                  role: "menuItem",
                  tabindex: 0
                },
                className: "uitk-list-item",
                label: formatText(locKeys.flightPreferredClassBusiness),
                typeAnchor: true,
                onClick: props.onSelectPreferredClassCode("b")
              },
              {
                attributes: {
                  role: "menuItem",
                  tabindex: 0
                },
                className: "uitk-list-item",
                label: formatText(locKeys.flightPreferredClassFirstClass),
                typeAnchor: true,
                onClick: props.onSelectPreferredClassCode("f")
              }
            ]}
          />
        </UitkMenuContainer>
      </UitkMenu>
    </UitkLayoutFlexItem>
  );
});
